import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { PSDocument } from '../model/document.interface';
import { classByKey, DocumentClassKey } from '@ps-gui/shared-core';

@Component({
  selector: 'shared-dp-document-preview-separator',
  template: `
    <fieldset
      class="text-secondary my-3 w-full border-0 border-t border-dashed text-sm"
      [ngClass]="!splitFunctionality() ? 'border-primary' : 'border-secondary'">
      <legend class="m-auto px-4">
        @if (!documentSeparatorLabelTemplate()) {
          @let classes = document().documentClasses;
          @if (classes.length === 0) {
            (Keine Klasse)
          } @else {
            Klasse {{ joinDocumentClassLabels(document().documentClasses) }}
          }
        } @else {
          <ng-container
            [ngTemplateOutlet]="documentSeparatorLabelTemplate()"
            [ngTemplateOutletContext]="{ $implicit: document(), index: documentIndex() }" />
        }
      </legend>
    </fieldset>
  `,
  imports: [NgTemplateOutlet, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentPreviewSeparatorComponent {
  readonly splitFunctionality = input<boolean>(false);
  readonly documentIndex = input.required<number>();
  readonly document = input.required<PSDocument>();

  readonly documentSeparatorLabelTemplate =
    input<TemplateRef<{ $implicit: PSDocument; index: number }>>();

  protected joinDocumentClassLabels(documentClasses: DocumentClassKey[]) {
    return documentClasses.map((documentClass) => classByKey[documentClass].label).join(' + ');
  }
}
